import { Routes, Route } from 'react-router-dom'
import { I18nextProvider } from 'react-i18next'
import i18n from './i18n' // i18n配置

// 自定义界面组件
// import { LoginPage } from './views/LoginView'
// import { AccountMgmtPage } from './views/AccountMgmtView'
// import { FirmwarePage } from './views/FirmwareView'
// import { AccountDetailPage } from './views/AccountDetailView'
// import { UserAccountDetailPage } from './views/UserAccountDetailView'
// import { EcgPage } from './views/EcgView'
// import { EcgShowPage } from './views/EcgShowView'
// import { ROOT } from './services/Api'
// import { HrvShowPage } from './views/HrvShowView'
// import { SystemPage } from './views/SystemView'
// import { StatsPage } from './views/StatsView'
// import { PrivacyPolicyPage } from './views/PrivacyPolicyView'
// import { TermsOfServicePage } from './views/TermsOfServiceView'
// import { LogsPage } from './views/LogsView'
// import { CalendarPage } from './views/CalendarView'
// import { PrivacyPage } from './views/PrivacyView'
// import { ServicePage } from './views/ServiceView'
// import { DynamicPage } from './views/DynamicView'
// import { UserDynamicPage } from './views/UserDynamicView'
// import { Page } from './services/Page'
// import { PushMgmtPage } from './views/PushView'
// import { ResetPage } from './views/ResetView'


// antd组件
import { LoginPage } from './antdviews/LoginView';
import { ResetPage } from './antdviews/ResetView';
import { AccountMgmtPage } from './antdviews/AccountMgmtView';
import { AccountDetailPage } from './antdviews/AccountDetailView';
import { FirmwarePage } from './antdviews/FirmwareView';
import { SystemPage } from './antdviews/SystemView';
import { StatsPage } from './antdviews/StatsView';
import { LogsPage } from './antdviews/LogsView';
import { DynamicPage } from './antdviews/DynamicView';
import { PushMgmtPage } from './antdviews/PushView';
import { UserAccountDetailPage } from './antdviews/UserAccountDetailView';
import { UserDynamicPage } from './antdviews/UserDynamicView';
import { EdfTaskPage } from './antdviews/EdfTaskView';

import { PrivacyPolicyPage } from './views/PrivacyPolicyView'
import { TermsOfServicePage } from './views/TermsOfServiceView'
import { CalendarPage } from './views/CalendarView'
import { PrivacyPage } from './views/PrivacyView'
import { ServicePage } from './views/ServiceView'
import { EcgPage } from './views/EcgView'
import { EcgShowPage } from './views/EcgShowView'
import { ROOT } from './services/Api'
import { HrvShowPage } from './views/HrvShowView'
import { Page } from './services/Page'


// SDK 已经全部使用 antd 
import { SdkPage } from './views/SdkView'
import { SdkLoginPage } from './views/SdkLoginView'
import { SdkRegisterPage } from './views/SdkRegisterView'
// import { SdkMgmtPage } from './views/SdkMgmtView'
// import { SdkTestPage } from './views/SdkTestView'
import { SdkTestPageTry } from './views/SdkTestViewTry'
import { SdkDevPage } from './views/SdkDevView'
import SdkDocView from './views/SdkDocView'

import { loadTheme } from './theme/themeConfig'
import './antdviews/styles/theme.css';

// 加载主题
loadTheme()

function App() {

    let lang = localStorage.getItem('lang') || 'zh_CN'
    console.log(`init lang:`, lang)
    i18n.changeLanguage(lang)

    let langEn = { lan: 'en_US' }
    let langZh = { lan: 'zh_CN' }

    return (
        <I18nextProvider i18n={i18n}>
            <div className="App">
                <Routes>
                    <Route path={`${ROOT}`} element={<LoginPage />} />
                    <Route path={`${ROOT}/${Page.login}`} element={<LoginPage />} />
                    <Route path={`${ROOT}/${Page.reset}`} element={<ResetPage />} />
                    {/* <Route path="/dashboard" element={<DashboardPage />} /> */}
                    <Route path={`${ROOT}/${Page.accountMgmt}`} element={<AccountMgmtPage />} />
                    <Route path={`${ROOT}/${Page.accountDetail}`} element={<AccountDetailPage />} />
                    <Route path={`${ROOT}/${Page.firmware}`} element={<FirmwarePage />} />
                    <Route path={`${ROOT}/${Page.system}`} element={<SystemPage />} />
                    <Route path={`${ROOT}/${Page.stats}`} element={<StatsPage />} />
                    <Route path={`${ROOT}/${Page.logs}`} element={<LogsPage />} />
                    <Route path={`${ROOT}/${Page.dynamic}`} element={<DynamicPage />} />
                    <Route path={`${ROOT}/${Page.calendar}`} element={<CalendarPage />} />
                    <Route path={`${ROOT}/${Page.pushMgmt}`} element={<PushMgmtPage />} />
                    <Route path={`${ROOT}/${Page.edfTask}`} element={<EdfTaskPage />} />
                    <Route path={`${ROOT}/${Page.ecg}`} element={<EcgPage />} />
                    <Route path={`${ROOT}/${Page.ecgShow}`} element={<EcgShowPage />} />
                    <Route path={`${ROOT}/${Page.hrvShow}`} element={<HrvShowPage />} />
                    {/* <Route path="/logMgmt" element={<DashboardPage />} /> */}

                    <Route path={`${ROOT}/${Page.userAccountMgmt}`} element={<UserAccountDetailPage />} />
                    <Route path={`${ROOT}/${Page.userDynamic}`} element={<UserDynamicPage />} />

                    {/* 其他路由配置 */}
                    <Route path={`${ROOT}/${Page.privacyPolicy}`} element={<PrivacyPolicyPage />} />
                    <Route path={`${ROOT}/${Page.termsOfService}`} element={<TermsOfServicePage />} />
                    {/* 如果有子路径，反应速度会很慢，且样式丢失 */}
                    <Route path={`${ROOT}/${Page.privacy_policy_en}`} element={<PrivacyPolicyPage {...langEn} />} />
                    <Route path={`${ROOT}/${Page.privacy_policy_zh}`} element={<PrivacyPolicyPage {...langZh} />} />
                    <Route path={`${ROOT}/${Page.terms_of_service_en}`} element={<TermsOfServicePage {...langEn} />} />
                    <Route path={`${ROOT}/${Page.terms_of_service_zh}`} element={<TermsOfServicePage {...langZh} />} />
                    <Route path={`${ROOT}/privacy_en`} element={<PrivacyPage {...langEn} />} />
                    <Route path={`${ROOT}/privacy_zh`} element={<PrivacyPage {...langZh} />} />
                    <Route path={`${ROOT}/service_en`} element={<ServicePage {...langEn} />} />
                    <Route path={`${ROOT}/service_zh`} element={<ServicePage {...langZh} />} />
                    <Route path={`${ROOT}/sdk_en`} element={<SdkPage {...langEn} />} />
                    <Route path={`${ROOT}/sdk_zh`} element={<SdkPage {...langZh} />} />
                    <Route path={`${ROOT}/${Page.sdkIntro}`} element={<SdkPage {...langZh} />} />
                    <Route path={`${ROOT}/${Page.sdkRegister}`} element={<SdkRegisterPage />} />
                    <Route path={`${ROOT}/${Page.sdkLogin}`} element={<SdkLoginPage />} />
                    {/* <Route path={`${ROOT}/${Page.sdkMgmt}`} element={<SdkMgmtPage />} /> */}
                    {/* <Route path={`${ROOT}/${Page.sdkTest}`} element={<SdkTestPage />} /> */}
                    <Route path={`${ROOT}/${Page.sdkTest}`} element={<SdkTestPageTry />} />
                    <Route path={`${ROOT}/${Page.sdkDev}`} element={<SdkDevPage />} />
                    <Route path={`${ROOT}/${Page.sdkDoc}`} element={<SdkDocView />} />
                </Routes>
            </div>
        </I18nextProvider>
    )
}

export default App